var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 6.875L23.8727 15.0078M5.625 6.875L6.38076 19.406C6.57432 22.6152 6.67109 24.2199 7.47336 25.3738C7.86999 25.9443 8.381 26.4258 8.97382 26.7878C9.81293 27.3001 10.8513 27.4538 12.5 27.5",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.75L16.25 27.4994M25 27.5L16.25 18.7506",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.875H26.25M20.0697 6.875L19.2163 5.11466C18.6495 3.94532 18.366 3.36065 17.8771 2.99601C17.7687 2.91512 17.6539 2.84318 17.5338 2.78088C16.9924 2.5 16.3426 2.5 15.0432 2.5C13.711 2.5 13.045 2.5 12.4946 2.79265C12.3726 2.85751 12.2562 2.93237 12.1466 3.01646C11.652 3.39588 11.3758 4.00194 10.8233 5.21407L10.0662 6.875",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOrg);
export default __webpack_public_path__ + "static/media/DeleteOrg.16d633f85f4f91048dbd30b0ebcf64c3.svg";
export { ForwardRef as ReactComponent };